import { Loader } from '../Loader';

const LOADER_EXIT_START_EVENT = 'sav:loader-exit-start';

export const configureLoader = () => {
    // ReactWP uses the built-in loader by default.
    // Uncomment this example if you want a v2-like animation flow:
    // keep animating while critical loading is still running,
    // then exit only when window.loader.isLoaded becomes true.
    /*
    */
    Loader.setAnimation(({ gsap, ScrollTrigger }) => {
        let tl = gsap.timeline({
            delay: .8,
            onComplete: () => {
                tl.kill();
                tl = null;
            }
        });

        tl
            .to({}, {
                duration: 0.1
            })
            .add(() => {
                if(!window.loader?.isLoaded){
                    tl.restart();
                    return;
                }
            })
            .to('#loader', .8, {
                opacity: 0,
                pointerEvents: 'none',
                ease: 'power4',
                onStart: () => {
                    ScrollTrigger?.refresh();
                    window.dispatchEvent(new CustomEvent(LOADER_EXIT_START_EVENT));
                }
            })
            .to('#loader svg', .8, {
                scale: 0,
                ease: 'power4'
            }, '<');

        return tl;
    });
};
